export var DEFAULT_ACTIVE_COLOR = '#e03d43';
export var DEFAULT_INITIAL_COUNT = 0;